import type {
  CreateSsoDomainIdentityProviderInput,
  DeleteSsoDomainIdentityProviderInput,
  SsoDomainIdentityProviderCondition,
  UpdateSsoDomainIdentityProviderInput,
} from "../../remote/gql/graphql";
import type { AlaffiaClientModuleArgs } from "./modules";

import { createSsoDomainIdentityProviderMutationDoc } from "../../remote/mutations/createSsoDomainIdentityProvider.gql";
import { deleteSsoDomainIdentityProviderMutationDoc } from "../../remote/mutations/deleteSsoDomainIdentityProvider.gql";
import { updateSsoDomainIdentityProviderMutationDoc } from "../../remote/mutations/updateSsoDomainIdentityProvider.gql";
import { getSsoDomainIdentityProvidersQueryDoc } from "../../remote/queries/getSsoDomainIdentityProviders.gql";
import { AlaffiaClientModule } from "./modules";

type SsoDomainIdentityProvidersModuleArgs = AlaffiaClientModuleArgs;

export class SsoDomainIdentityProvidersModule extends AlaffiaClientModule {
  constructor(args: SsoDomainIdentityProvidersModuleArgs) {
    super(args);
  }

  getSsoDomainIdentityProviders = async (input: {
    condition?: SsoDomainIdentityProviderCondition | null;
    first?: number | null;
    offset?: number | null;
  }) => {
    const result = await this.runGqlQuery(
      getSsoDomainIdentityProvidersQueryDoc,
      {
        condition: input.condition ?? null,
        first: input.first ?? null,
        offset: input.offset ?? null,
      },
      "getSsoDomainIdentityProviders",
    );

    return {
      data: result.data?.ssoDomainIdentityProviders ?? null,
      error: result.error ?? null,
    };
  };

  createSsoDomainIdentityProvider = async (input: {
    input: CreateSsoDomainIdentityProviderInput;
  }) => {
    const result = await this.runGqlMutation(
      createSsoDomainIdentityProviderMutationDoc,
      { input: input.input },
      "createSsoDomainIdentityProvider",
    );

    return {
      data:
        result.data?.createSsoDomainIdentityProvider
          ?.ssoDomainIdentityProvider ?? null,
      error: result.error ?? null,
    };
  };

  updateSsoDomainIdentityProvider = async (input: {
    input: UpdateSsoDomainIdentityProviderInput;
  }) => {
    const result = await this.runGqlMutation(
      updateSsoDomainIdentityProviderMutationDoc,
      { input: input.input },
      "updateSsoDomainIdentityProvider",
    );

    return {
      data:
        result.data?.updateSsoDomainIdentityProvider
          ?.ssoDomainIdentityProvider ?? null,
      error: result.error ?? null,
    };
  };

  deleteSsoDomainIdentityProvider = async (input: {
    input: DeleteSsoDomainIdentityProviderInput;
  }) => {
    const result = await this.runGqlMutation(
      deleteSsoDomainIdentityProviderMutationDoc,
      { input: input.input },
      "deleteSsoDomainIdentityProvider",
    );

    return {
      data:
        result.data?.deleteSsoDomainIdentityProvider
          ?.ssoDomainIdentityProvider ?? null,
      error: result.error ?? null,
    };
  };
}
